import { SuccessFill } from '@bblabs/module-library/svgs';
import React from 'react';
import './EmailSent.scss';

export function EmailSent() {
  return (
    <div className="notification--email-sent">
      <div className="icon">
        <SuccessFill title="" />
      </div>
      <h1>Your email has been delivered!</h1>
      <p>Select or compose a new message</p>
    </div>
  );
}
